import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

// Editorial FAQ accordion. One item open at a time, thin bottom borders,
// no boxes or shadows — matches the site's minimal aesthetic.
export function FAQ({ title, items = [] }) {
  const [open, setOpen] = useState(null);

  return (
    <section className="bg-paper py-24 md:py-36 px-6 md:px-12" data-testid="faq-block">
      <div className="max-w-3xl mx-auto">
        <h2 className="font-heading font-semibold italic tracking-tight leading-[1.1] text-3xl md:text-5xl text-ink">
          {title}
        </h2>
        <div className="mt-14" data-testid="faq-list">
          {items.map((item, i) => {
            const isOpen = open === i;
            return (
              <div
                key={i}
                className="border-b border-borderline"
                data-testid={`faq-item-${i}`}
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? null : i)}
                  className="w-full flex justify-between items-start gap-6 py-7 text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent"
                  data-testid={`faq-question-${i}`}
                  aria-expanded={isOpen}
                >
                  <span className="font-body text-lg md:text-xl text-ink leading-snug">
                    {item.q}
                  </span>
                  <span
                    className={`shrink-0 text-accent text-3xl leading-none pt-1 transition-transform duration-200 ${
                      isOpen ? "rotate-45" : ""
                    }`}
                    aria-hidden="true"
                  >
                    +
                  </span>
                </button>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      key="content"
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.2, ease: "easeOut" }}
                      className="overflow-hidden"
                      data-testid={`faq-answer-${i}`}
                    >
                      <p className="font-body text-base md:text-lg text-secondary leading-[1.75] pb-7 pr-10 max-w-2xl">
                        {item.a}
                      </p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
